import React from "react";
import styles from "../../../../styles/AdminConsole.module.css";

/**
 * StatCard
 *
 * Props:
 *   label      string   — top label
 *   value      string | number — large centre figure
 *   sub        string   — small subtitle below value
 *   form       bool     — when true renders the wider form-card variant
 *   children   node     — rendered inside formInner when form=true
 */
const StatCard = React.memo(function StatCard({
  label,
  value,
  sub,
  form = false,
  children,
}) {
  if (form) {
    return (
      <div className={`${styles.statCard} ${styles.statCardForm}`}>
        <div className={styles.statLabel}>{label}</div>
        <div className={styles.formInner}>{children}</div>
      </div>
    );
  }

  return (
    <div className={styles.statCard}>
      <div className={styles.statLabel}>{label}</div>
      <div className={styles.statValue}>{value}</div>
      <div className={styles.statSub}>{sub}</div>
    </div>
  );
});

export default StatCard;
